export const environment = {
  production: true,
  occ: {},
  oidc: {
    subaru: {
      clientId: 'subaru-efa',
      clientSecret: 'PYwf1KyJNjXCVVuIHEqx',
      issuer: 'https://auth.asp.itt-dev.de',
      loginUrl: 'oauth2/authorize',
      tokenEndpoint: 'oauth2/token',
      baseUrl:
        'https://auth.asp.itt-dev.de',
      userinfoEndpoint: 'userinfo',
      revokeEndpoint: 'oauth2/revoke',
    },
  },
  siteIdToUrlSubDirectory: {
    subaru: 'subaru',
  },
};
